import { createStore } from '@blocks/base/store';
import user from './modules/user';
import goto from './modules/goto';
import task from './modules/task.js';
import lottery from './modules/lottery.js';
import coupon from './modules/coupon.js';
import brand from './modules/brand.js';
import inquiry from './modules/inquiry.js';
import seeCar from './modules/seeCar.js';
import my from './modules/my.js';
import config from './modules/config.js';
import city from '@blocks/city/module';
import shareLink from '@blocks/shareLink/module';
import shareImage from '@blocks/shareImage/module';
export default createStore({
  modules: {
    user,
    goto,
    task,
    lottery,
    coupon,
    brand,
    inquiry,
    seeCar,
    my,
    config,
    city,
    shareLink,
    shareImage,
  },
});
